import { render, staticRenderFns } from "./SavingsDetailsTableMail.vue?vue&type=template&id=b2225bdc&scoped=true&"
import script from "./SavingsDetailsTableMail.vue?vue&type=script&lang=js&"
export * from "./SavingsDetailsTableMail.vue?vue&type=script&lang=js&"
import style0 from "./SavingsDetailsTableMail.vue?vue&type=style&index=0&id=b2225bdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2225bdc",
  null
  
)

export default component.exports